import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';

@Injectable({
  providedIn: 'root',
})
export class GifService {
  public apiEndPoint = apiParameters.url;

  constructor(private httpClient: HttpClient) {}

  getGifs(): Observable<any> {
    const url = apiParameters.url + '/gifs';
    return this.httpClient.get(url);
  }

  addGif(body): Observable<any> {
    const url = apiParameters.url + '/gifs';
    return this.httpClient.post(url, body);
  }

  getGif(gifId): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId;
    return this.httpClient.get(url);
  }

  editGif(gifId, body): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId;
    return this.httpClient.patch(url, body);
  }

  deleteGif(gifId): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId;
    return this.httpClient.delete(url);
  }

  getGifPresets(gifId): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId + '/presets';
    return this.httpClient.get(url);
  }

  addGifToPreset(gifId, body): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId + '/presets'
    return this.httpClient.post(url, body);
  }

  editGifToPreset(gifId, presetId, body): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId + '/presets/' + presetId
    return this.httpClient.patch(url, body);
  }

  removeGifFromPreset(gifId,presetId): Observable<any> {
    const url = apiParameters.url + '/gifs/' + gifId + '/presets/' + presetId;
    return this.httpClient.delete(url);
  }

  makeGif(userId: string, vehicleId: string) {
    const url = `${apiParameters.urlV2}/users/${userId}/vehicles/${vehicleId}/gif`;
    return this.httpClient.patch(url, {});
  }
}
